import Vue, { VueConstructor } from "vue";

import { formatAge, formatDate, formatDateTime, formatTime, formatTimeFromNow } from "./datetime";
import { displayGender, displayVaeSurveillanceType } from "./enums";
import { formatPatientName } from "./patientName";
import { formatTitlecase } from "./titlecase";
import { formatUserName } from "./userName";
import {
    formatVentBoolean,
    formatVentFiO2Monitoring,
    formatVentNumber,
    formatVentText,
    formatVentUnits,
    formatVentValue
} from "./ventFields";

export function registerFilters(vue: VueConstructor<Vue>) {
  vue.filter("age", formatAge);
  vue.filter("date", formatDate);
  vue.filter("dateTime", formatDateTime);
  vue.filter("gender", displayGender);
  vue.filter("vaeSurveillanceType", displayVaeSurveillanceType);
  vue.filter("patientName", formatPatientName);
  vue.filter("time", formatTime);
  vue.filter("timeFromNow", formatTimeFromNow);
  vue.filter("titlecase", formatTitlecase);
  vue.filter("userName", formatUserName);
  vue.filter("ventBoolean", formatVentBoolean);
  vue.filter("ventNumber", formatVentNumber);
  vue.filter("ventText", formatVentText);
  vue.filter("ventValue", formatVentValue);
  vue.filter("ventFiO2Monitoring", formatVentFiO2Monitoring);
  vue.filter("ventUnits", formatVentUnits);
}
